import Konva from 'konva';
import { forwardRef } from 'react';
import { Line } from 'react-konva';
import { ShapeId } from 'store/slices/TreeSlice';

export const POLYGON_STROKE = 'rgba(255, 255, 255, 0.8)';
export const POLYGON_FILL = 'rgba(255, 255, 255, 0.45)';
export const POLYGON_FILL_ACTIVE = 'rgba(255, 255, 255, 0.6)';
export const POLYGON_STROKE_WIDTH = 1.5;
export const POLYGON_DASH = [6, 4];

interface FlattenAreaPolygonProps extends Konva.LineConfig {
	isActive?: boolean;
	isHovered?: boolean;
	polygonId: ShapeId;
	// View mode passes false — FlattenAreaFillLayer already draws the fill, avoids double fill.
	showFill?: boolean;
}

const FlattenAreaPolygon = forwardRef<Konva.Line, FlattenAreaPolygonProps>(
	({ isActive, isHovered, polygonId, showFill = true, ...rest }, ref) => {
		const fill = isActive || isHovered ? POLYGON_FILL_ACTIVE : (showFill ? POLYGON_FILL : 'transparent');
		return (
			<Line
				ref={ref}
				id={`FLATTEN_AREA-${polygonId}`}
				stroke={POLYGON_STROKE}
				strokeWidth={POLYGON_STROKE_WIDTH}
				dash={POLYGON_DASH}
				strokeScaleEnabled={false}
				closed={true}
				fill={fill}
				{...rest}
			/>
		);
	}
);

FlattenAreaPolygon.displayName = 'FlattenAreaPolygon';
export default FlattenAreaPolygon;
